import moment from 'moment';

/**
 * Creates a new date object for the given day, month, and year in local time zone
 * @param day the day you wish this object to represent
 * @param month the numeric value of the month
 * @param year the full four digit value of the year
 * @returns A date object corresponding to the new day, month, and year
 */
export const getDate = (day, month, year) => {
	return moment({ year: year, month: month, day: day });
};

/**
 * Creates a new date object for the given day, month, and year in UTC
 * @param day the day you wish this object to represent
 * @param month the numeric value of the month
 * @param year the full four digit value of the year
 * @returns A date object corresponding to the new day, month, and year
 */
export const getUtcDate = (day, month, year) => {
	return moment.utc({ year: year, month: month, day: day });
};

export const extractDate = (date, isDateTime) => {
  return isDateTime ? moment(date).format('YYYY-MM-DD') : moment.utc(date).format('YYYY-MM-DD');
};


// WEBPACK FOOTER //
// ./src/utils/DateUtils.js